/** Canonical portal paths (Google-friendly, history mode) */
export const R = {
  HOME: '/',
  ABOUT: '/about',
  PROJECTS: '/projects',
  PRODUCTS: '/products',
  PRODUCT_CATALOG: '/products/catalog',
  PRODUCT_MATRIX: '/products/positioning-matrix',
  PRODUCT_CAPABILITY: '/products/capability-matrix',
  PRODUCT_RF_DETECTION: '/products/radio-detection',
  PRODUCT_COUNTER_B: '/products/countermeasure-system',
  PRODUCT_INTEGRATED: '/products/integrated-system',
  SOLUTION_INDUSTRY: '/solutions/industry',
  SOLUTION_CUAS: '/solutions/c-uas',
  SOLUTION_CUAS_ZH: '/solutions/c-uas-zh',
  SOLUTION_CUAS_EN: '/solutions/c-uas-en',
  SOLUTION_DRONE: '/solutions/drone-defense'
};

/** Legacy lanhu paths → canonical (for redirects & active-key matching) */
export const LEGACY_PATH_MAP = {
  '/lanhu_1shouye': R.HOME,
  '/lanhu_about': R.ABOUT,
  '/lanhu_project_site': R.PROJECTS,
  '/lanhu_7chanpinliebiao': R.PRODUCTS,
  '/lanhu_2chanpinliebiao': R.PRODUCT_CATALOG,
  '/lanhu_9chanpinjuzhen': R.PRODUCT_MATRIX,
  '/lanhu_wurenjijiejuefangan': R.PRODUCT_CAPABILITY,
  '/lanhu_3chanpinxiangqinga': R.PRODUCT_RF_DETECTION,
  '/lanhu_4chanpinxiangqingb': R.PRODUCT_COUNTER_B,
  '/lanhu_8chanpinxiangqinga': R.PRODUCT_INTEGRATED,
  '/lanhu_10hangyejiejuefangan': R.SOLUTION_INDUSTRY,
  '/lanhu_10hangyejiejuefangan_1': R.SOLUTION_CUAS,
  '/lanhu_jiejuefanganzhongwen': R.SOLUTION_CUAS_ZH,
  '/lanhu_jiejuefanganyingwen': R.SOLUTION_CUAS_EN,
  '/lanhu_cuasjiejuefangan': R.SOLUTION_CUAS_ZH,
  '/lanhu_cuasjiejuefangan_en': R.SOLUTION_CUAS_EN
};

export function normalizeLegacyPath(path) {
  return LEGACY_PATH_MAP[path] || path;
}
